import objectAssign from 'object-assign';
import RestHelper from '../utils/RestHelper';

function saveInternetAccessData(internetAccessData, endpoint) {
  const params = {
    params: internetAccessData
  };
  return RestHelper
    .post(endpoint, params);
}

export const loadDataInitiation = (dispatch, component) => {
  dispatch({
    type: 'INIT_INTERNETACCESS_DATA',
    data: {
      component
    }
  });
};

export const dataRequest = (dispatch, state) => {
  dispatch({
    type: 'SUBMIT_INTERNETACCESS_DATA',
    data: {
      values: state
    }
  });
};

export const dataRequestSuccess = (dispatch, response) => {
  dispatch({
    type: 'SUBMIT_SUCCESSFUL',
    data: {
      response: response.data
    }
  });
};

export const dataRequestError = (dispatch, error) => {
  dispatch({
    type: 'SUBMIT_ERROR',
    data: {
      error
    }
  });
};

export const submitData = (dispatch, data, submitEndpoint) => {
  const resp = saveInternetAccessData(data, submitEndpoint);
  dataRequest(dispatch, data, submitEndpoint);
  return resp
    .then((response) => {
      dataRequestSuccess(dispatch, response);
    }).catch((err) => {
      dataRequestError(dispatch, err);
      console.error(err); // eslint-disable-line no-console
    });
};

export default function reducer(state = {}, action = {}) {
  switch (action.type) {
    case 'INIT_INTERNETACCESS_DATA': {
      return objectAssign({}, state, action.data);
    }
    case 'SUBMIT_INTERNETACCESS_DATA': {
      return objectAssign({}, state, action.data, { isRequestPending: true });
    }
    case 'SUBMIT_SUCCESSFUL': {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: true });
    }
    case 'SUBMIT_ERROR': {
      return objectAssign({}, state, action.data, { isRequestPending: false, isSuccess: false });
    }
    default:
      return state;
  }
}
